import { TreeNode } from '../route-builder';

export const MercerModule = {
  segment: 'mercer',
  children: {
    MercerPositionListViewComponent: { segment: 'list-view', params: ['seasonId', 'filter', 'tags'] }
  }
} as const satisfies TreeNode;
